import React, { useEffect, useState } from 'react';

import { Button, Popover, Space, Typography, Divider } from 'antd';
import { EditFilled, DeleteOutlined, RedoOutlined } from '@ant-design/icons';

import moment from 'moment';

const EventPopover = (props) => {
  const { item, onEditEvent, onDeleteEvent, rootContainer } = props;
  const [showTooltip, setShowTooltip] = useState(false);

  const onConfirmDelete = (domEvent, eventItem) => {
    domEvent.preventDefault();
    domEvent.stopPropagation();

    setShowTooltip(!showTooltip);
    onDeleteEvent(eventItem);
  };

  const onOpenEditEvent = (domEvent, item) => {
    domEvent.preventDefault();
    domEvent.stopPropagation();

    setShowTooltip(!showTooltip);
    onEditEvent(domEvent, item);
  };

  const eventPopoverTitle = (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
      <span>
        {item.recurrenceObject && <RedoOutlined title="" style={{ paddingRight: '5px' }} />} {item.startObj.format('MMM DD, YYYY hh:mm A')}
      </span>
      <div style={{ display: 'flex' }}>
        <Button
          shape="circle"
          type="text"
          title="Delete"
          icon={<DeleteOutlined />}
          onClick={($event) => {
            onConfirmDelete($event, item);
          }}
        />
        <Button
          shape="circle"
          type="text"
          title="Edit"
          icon={<EditFilled />}
          onClick={($event) => {
            onOpenEditEvent($event, item);
          }}
        />
      </div>
    </div>
  );

  const cellPopoverContent = (
    <div style={{ width: '300px' }}>
      <p>{item.subject}</p>

      {item &&
        item.recurrenceObject &&
        item.recurrenceObject.excludeOccurencesPeriods &&
        item.recurrenceObject.excludeOccurencesPeriods.length > 0 && (
          <>
            <Divider type="horizontal" />
            <Space direction="horizontal">
              <Typography.Text>Excluded durations:</Typography.Text>
              <Space direction="vertical">
                {item.recurrenceObject.excludeOccurencesPeriods.map((p, index) => (
                  <span key={'skipped-' + index}>
                    {moment(p.startDate).format('MMM DD, YYYY hh:mm A')} - {moment(p.endDate).format('MMM DD, YYYY hh:mm A')}
                  </span>
                ))}
              </Space>
            </Space>
          </>
        )}
    </div>
  );

  return (
    <Popover
      title={eventPopoverTitle}
      content={cellPopoverContent}
      getPopupContainer={rootContainer}
      trigger="click"
      placement="rightTop"
      open={showTooltip}
      onOpenChange={setShowTooltip}
    >
      {props.children}
    </Popover>
  );
};

export default EventPopover;
